import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import React from "react";

const InventoryModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();

    const productColumns: Array<Column> = new Array();
    productColumns.push({key:'product.code',dataIndex:["product","code"], width: 200, fixed: 'left', sorter:true,title:<Trans>Code</Trans>, render: (text, row) => ({ props: { style: { background: '#fbfbfb'} }, children: <div>{text}</div> })});
    productColumns.push({key:'product.name',dataIndex:["product","name"], width: 370, fixed: 'left', sorter:true,title:<Trans>Name</Trans>, render: (text, row) => ({ props: { style: { background: '#fbfbfb'} }, children: <div>{text}</div> })});
    productColumns.push({key:'lotNumber', width: 150, fixed: 'left', sorter:true,title:<Trans>Lot</Trans>, render: (text, row) => ({ props: { style: { background: '#fbfbfb'} }, children: <div>{text}</div> })});
    columns.push({
        key: 'product',
        width: 157,
        sorter: false,
        filter: false,
        title: <Trans>Product</Trans>,
        children: productColumns,
    });

    const qtyColumns: Array<Column> = new Array();
    qtyColumns.push({key:'quantity', width: 130, sorter:true, title:<Trans>Stock</Trans>,

        render: (text, row) => ({ props: { style: { background:
                        row["quantity"] !== row["difference"] ? '#fffbe6' : ''
                } }, children: <div>{text}</div> })
    });

    qtyColumns.push({key:'difference', width: 140, sorter:true, title:<Trans>Difference</Trans>,

        render: (text, row) => ({ props: { style: { background:
                        row["quantity"] !== row["difference"] ? '#fffbe6' : ''
                } }, children: <div>{text}</div> })
    });


    columns.push({
        key: 'qty',
        width: 157,
        sorter: false,
        filter: false,
        title: <Trans>Quantity</Trans>,
        children: qtyColumns
    });

    columns.push({key:'slot', dataIndex:["slot"], width: 150, sorter:true,title:<Trans>Slot</Trans>,
        render: (text, row) =>
            ({
                children:
                    row["slot"]
                        ?
                        <div>
                            {row["slot"]["rack"]}:
                            {row["slot"]["row"]}:
                            {row["slot"]["col"]}
                        </div>
                        : <></>
            }),
    });

    columns.push({key:'status',tags:[
            {text:'CREATED',color:'blue'},
            {text:'APPROVED',color:'green'},
            {text:'REJECTED',color:'red'},
        ],
        uniqueSelectFilterData:[
            {
                label:<Trans>NONE</Trans>,
                value:null
            },{
                label:<Trans>CREATED</Trans>,
                value:"CREATED"
            },{
                label:<Trans>APPROVED</Trans>,
                value:"APPROVED"
            },{
                label:<Trans>REJECTED</Trans>,
                value:"REJECTED"
            }        ],
        width: 150, sorter:true,title:<Trans>Status</Trans>
    });
    columns.push({key:'uploadedToKulcsSoft', width: 160, sorter:true, checkboxFilter: true, title:<Trans>Uploaded To KS</Trans>});
    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, dateFilter:true, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, direction:"desc", dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>});
    columns.push({key:'createdBy', width: 200, dateFilter:true, sorter:true,title:<Trans>Created By</Trans>});


    return{
        columns:columns,
        url:"/resource/inventory"
    };
}
export default InventoryModel();
